import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { PropertyTagsUser } from 'lumen/models';
import type CustomTagDefinition from 'lumen/models/custom-tag-definition';
import type CustomTagListOption from 'lumen/models/custom-tag-list-option';
import type PropertyTagsSubscription from 'lumen/models/property-tags/subscription';

export default class CustomTagValue extends Model {
  [Type] = 'custom-tag-value' as const;

  @belongsTo('custom-tag-definition', { async: false, inverse: null })
  declare definition: CustomTagDefinition;

  @belongsTo('custom-tag-list-option', { async: false, inverse: null })
  declare listOption: CustomTagListOption | null;

  @belongsTo('property-tags/subscription', { async: false, inverse: null })
  declare subscription: PropertyTagsSubscription;

  @belongsTo('property-tags/user', { async: false, inverse: null })
  declare user: PropertyTagsUser | null;

  @attr('string') declare textValue: string | null;
}
